module.exports = __webpack_public_path__ + "img/About_ys_big_3.1051cf09.jpg";